<template>
    <div class="modal-dialog modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Icons</h4>
                <a class="modal-close" @click="$emit('CloseOrOpenIconModal', false)"><i class="fa fa-times"></i></a>
            </div>
            <form autocomplete="off" @submit="onSubmit">
                <div class="modal-body">                          
                    <div v-if="listIcons?.length > 0">                          
                         <span v-for="icons of listIcons" :key="icons.id" class="icon-pick">
                                <i @click="setIcon(icons.value)" :class="icons.text" aria-hidden="true" ></i>
                                
                               <!-- <vue-feather  type="{{ icons.text }}" size="18"></vue-feather>  -->
                         </span> 
                    </div>                  
                </div>
                <div class="modal-footer">
                    <!-- <div class="form-btn">
                        <button  href="javascript:;" class="btn btn-pill btn-gradient color-4">
                            Submit
                        </button>
                        <a href="javascript:;" class="btn btn-pill btn-danger"
                            @click="$emit('CloseOrOpenIconModal', false)">Cancel</a>
                    </div> -->
                </div>
            </form>
        </div>
    </div>
</template>


<script>
import { ref, onMounted } from "vue";
import CommonService from "@/service/crmservice/commonService";
export default {
    name: 'categoryattributeicon',


    setup(prop, ctx) {

        //================== variable =====================

        const commonService = ref(new CommonService());
        const listIcons = ref([]);
        const userId = ref(null);
        const companyId = ref(null);

        //=================== funcation =========================

        const getUserInfo = () => {
            userId.value = localStorage.getItem("userId");
            companyId.value = localStorage.getItem("companyId");
        };


        const getIcons = () => {
            listIcons.value = [];
            commonService.value
                .GetMasterItemsNotAuth("Icons", userId.value, null)
                .then((result) => {                              
                    listIcons.value = result.data;                
                });
        };

       const setIcon = (id) => {
            let data = [];
            data = listIcons.value.filter(x => x.value.toString() == id.toString());

           ctx.emit('SubmitIcon', data);
        }


        onMounted(() => {
            getUserInfo();
            getIcons();
        });

        //====================== return ===========================

        return {
            getIcons,
            getUserInfo,
            setIcon,
            listIcons
        }
    }
}
</script>

<style>
span.icon-pick {
    display: inline-block;
    padding: 5px;
    border: 1px solid #ddd;
    margin: 4px;
    width: 40px;
    text-align: center;
    font-size: 20px;
    height: 40px;
    overflow: hidden;
    border-radius: 5px;
    cursor: pointer;
    transition: all .3s;
}

span.icon-pick:hover {
    transform: scale(1.1);
    border-color: #41b2f9;
}

span.icon-ininput {
    position: relative;
    display: inline-block;
    width: 100%;
}

.selectedico {
    position: absolute;
    top: 10px;
    left: 10px;
}

.icon-ininput .form-control {
    border-radius: .2rem !important;
    border: 1px solid #bdbdbd;
    font-size: 0;
    min-height: 38px;
}</style>
 
 